import { CardInterface } from '@modules/card/interfaces/card.interface';
import { CardModel } from '@modules/card/models/card.model';

import { SectionType } from '../enums/section-type.enum';

import { Section } from './section.model';

export enum CarouselLayoutTypes {
  NINE_SIXTY = '9x16',
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
  SQUARE = 'square',
}
export interface CarouselSectionInterface {
  headline: string;
  anchor: string;
  type: SectionType;
  layout: CarouselLayoutTypes;
  teasers: CardInterface[];
}

export class CarouselSectionModel implements Section {
  public headline?: string;
  public anchor?: string;
  public type = SectionType.CAROUSEL;
  public teasers: CardModel[] = [];
  public ratio: number;

  constructor(data: CarouselSectionInterface) {
    this.headline = data.headline;
    this.anchor = data.anchor;
    this.type = data.type;
    this.teasers = data.teasers.map((card) => new CardModel(card));

    switch (data.layout) {
      case 'portrait':
        this.ratio = 2 / 3;
        break;

      case 'square':
        this.ratio = 1;
        break;

      case 'landscape':
        this.ratio = 16 / 9;
        break;

      case '9x16':
        this.ratio = 9 / 16;
        break;
      default:
        this.ratio = 16 / 9;
    }
  }
}
